import { Tooltip } from '@mantine/core';
import { IconBus, IconSailboat, IconTag, IconBuildingStore, IconUsers, IconSailboat2, IconCompass, IconBed, IconHome, IconAirBalloon, IconCash, IconBusOff, IconUser, IconUsersGroup, IconWheel, IconPacman, IconBuildingArch, IconBuildingCommunity, IconCircleDottedLetterH, IconBusStop, IconBusFilled, IconGift, IconBike, IconCar, IconHelicopter, IconPlane, IconTruckDelivery, IconSparkles, IconTrekking, IconHomeHeart, IconBalloonFilled, IconYoga, IconToolsKitchen2, IconPalette, IconCamera, IconMusic, IconLanguage, IconSchool, IconConfetti, IconMicrophone2, IconBuildingPavilion, IconMoodCrazyHappyFilled, IconPhotoScan, IconPhoto, IconCalendar, IconClipboardPlus, IconClipboardCheckFilled, IconLogs, IconCashBanknote, IconScale, IconCalendarWeekFilled, IconAdjustmentsHorizontal, IconGrowth, IconClipboardList, IconCalendarWeek, IconClipboardCheck, IconFileText, IconBuilding, IconHome2, IconMessageCircleUser, IconMessages, IconSteeringWheelFilled, IconUserPlus, IconTruck, IconListDetails, IconGraph, IconHistory, IconSortAscendingShapes, IconCalendarMonth, IconFilter2Search, IconRepeat, IconCashMove, IconDiscount, IconCalendarCheck, IconPackages, IconPackageExport, IconUserCheck, IconServer, IconGasStation, IconUserCode, IconUserStar, IconBabyCarriage } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';


const TAG_COLORS = {
    transfer: '#DBEAFE',
    transfers: '#DBEAFE',
    room: '#EDE9FE',
    rooms: '#EDE9FE',
    stay: '#EDE9FE',
    hotel: '#EDE9FE',
    hostel: '#EDE9FE',
    cabins: '#EDE9FE',
    rental_house: '#EDE9FE',
    lodging: '#FCE7F3',
    lake: '#D1FAE5',
    person: '#FEE2E2',
    agency: '#D1FAE5',
    ferry: '#DBEAFE',
    ferries: '#DBEAFE',
    tour: '#D1FAE5',
    tours: '#D1FAE5',
    coordinator: '#E6E1FF',
    pax: '#F3F3F3',
    adult: '#DBEAFE',
    senior: '#DBEAFE',
    child: '#DBEAFE',
    children: '#DBEAFE',
    infant: '#DBEAFE',
    guest: '#CCFBF1', // this is 100% being used as TC (staff)
    staff: '#CCFBF1',
    pax_holder: '#FFEDD5',
    service_groups: '#FFEDD5',
    service_group: '#FFEDD5',
    business: '#F3F4F6',
    businesses: '#F3F4F6',
    persons: '#F3F4F6',
    client: '#FEE2E2',
    clients: '#FEE2E2',
    payment: '#D1FAE5',
    reservations: '#DBEAFE',
}

export const getTagColor = (name: string) => {
    return TAG_COLORS[name as keyof typeof TAG_COLORS] || '#F3F4F6';
}

export const TAG_ICONS = {
    it_provider: IconServer,
    gas_station: IconGasStation,
    subscriptions: IconRepeat,
    reservations: IconCalendar,
    businesses: IconBuildingStore,
    paxs: IconUsersGroup,
    transfer: IconBus,
    transfers: IconBus,
    room: IconBed,
    rooms: IconBed,
    stay: IconBed,
    stays: IconBed,
    cabins: IconHome2,
    rental_house: IconHome,
    ferry: IconSailboat2,
    ferry_company: IconSailboat2,
    tours: IconPhoto,
    tour: IconPhoto,
    agency: IconCompass,
    lodging: IconHome,
    hotel: IconCircleDottedLetterH,
    hostel: IconBuildingCommunity,
    coordinator: IconMessageCircleUser,
    guide: IconMessages,
    driver: IconSteeringWheelFilled,
    carrier: IconTruck,
    transport: IconTruck,
    assistant: IconUserPlus,
    lake: IconSailboat,
    business: IconBuildingStore,
    person: IconUser,
    vendor: IconAirBalloon,
    vendors: IconAirBalloon,
    with_services: IconAirBalloon,
    client: IconCash,
    clients: IconCash,
    without_services: IconCash,
    with_vehicles: IconBus,
    staff: IconWheel,
    pax: IconUser,
    adult: IconUser,
    senior: IconUser,
    child: IconUser,
    children: IconUser,
    guest: IconUserStar,
    infant: IconBabyCarriage,
    pax_holder: IconUserCode,
    regular: IconBusStop,
    private: IconBusFilled,
    service_groups: IconGift,
    persons: IconUsers,
    bike_rental: IconBike,
    car_rental: IconCar,
    boat_rental: IconSailboat,
    sailing: IconSailboat,
    kayak: IconSailboat,
    rafting: IconSailboat,
    diving: IconSailboat,
    helicopter_rental: IconHelicopter,
    plane_rental: IconPlane,
    van_rental: IconTruckDelivery,
    experience: IconSparkles,
    adventure: IconTrekking,
    outdoor_adventure: IconTrekking,
    indoor_adventure: IconHomeHeart,
    dance_class: IconMoodCrazyHappyFilled,
    yoga_class: IconYoga,
    meditation_class: IconYoga,
    cooking_class: IconToolsKitchen2,
    painting_class: IconPalette,
    photography_class: IconCamera,
    music_class: IconMusic,
    language_class: IconLanguage,
    other_class: IconSchool,
    music: IconMusic,
    painting: IconPalette,
    photography: IconCamera,
    cooking: IconToolsKitchen2,
    meditation: IconYoga,
    yoga: IconYoga,
    concert: IconMicrophone2,
    festival: IconConfetti,
    music_festival: IconBuildingPavilion,
    language: IconLanguage,
    all: IconAirBalloon,
    services: IconAirBalloon,
    inventory_items: IconGrowth,
    inventory_calendar: IconCalendarWeek,
    create_service_bookings: IconClipboardList,
    service_orders: IconSortAscendingShapes,
    money_transactions: IconCashBanknote,
    balance: IconScale,
    history: IconHistory,
    metrics: IconGraph,
    ai_chat: IconSparkles,
    settings: IconAdjustmentsHorizontal,
    edit_tariffs: IconFileText,
    orders_calendar: IconCalendarWeek,
    orders_create: IconClipboardPlus,
    orders_show: IconClipboardList,
    tickets: IconListDetails,
    tasks: IconListDetails,
    calendar: IconCalendarWeek,
    service_order: IconSortAscendingShapes,
    agenda_orders: IconCalendarMonth,
    availability: IconFilter2Search,
    money_movements: IconCashMove,
    discount_categories: IconDiscount,
    reservation: IconCalendarCheck,
    service_group: IconGift,
}

export const TAG_PLURAL_ICONS = {
    transfers: IconBus,
    rooms: IconBed,
    stays: IconBed,
    tours: IconCompass,
}

export const TagIcon = ({
    name,
    extraText,
    size = 'xs',
    hideText = false,
    onClick,
    className,
    plural,
    uppercase = false,
    noBackground = false,
    isSelected = false,
    rounded = true,
    rightSection,
}: {
    name: string,
    extraText?: string,
    hideText?: boolean,
    onClick?: () => void,
    className?: string,
    size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl',
    plural?: boolean,
    uppercase?: boolean,
    noBackground?: boolean,
    isSelected?: boolean,
    rounded?: boolean,
    rightSection?: React.ReactNode,
}) => {
    const { t } = useTranslation();
    const Icon = TAG_ICONS[name as keyof typeof TAG_ICONS] || TAG_PLURAL_ICONS[name as keyof typeof TAG_PLURAL_ICONS] || IconTag;

    const tagColor = getTagColor(name);
    const classes = `
        ${className}
        flex gap-2
        items-center
        ${rounded ? 'rounded-full' : ''}
        text-${size}
        whitespace-nowrap
        w-fit 
        h-fit
        ${noBackground ? '' : 'px-2 py-1'}
        rounded-full
        ${onClick ? 'cursor-pointer' : ''}
        ${isSelected
            ? 'border-2 border-black-900 text-black-900 font-bold'
            : 'text-gray-600'
        }
        hover:text-black
    `;

    const iconSize = {
        xxs: 12,
        xs: 16,
        sm: 20,
        md: 24,
        lg: 26,
        xl: 28,
        '2xl': 30,
        '3xl': 32,
        '4xl': 34,
        '5xl': 36,
    }

    // Solid light pastel background color
    const backgroundColor = noBackground ? '' : (tagColor || '#f3f4f6');

    return (
        <Tooltip label={t(name)}>
            <div
                className={classes}
                onClick={onClick}
                style={{ backgroundColor: noBackground && !isSelected ? 'transparent' : backgroundColor }}
            >
                <div className='flex relative'>
                    <Icon className='shrink-0' size={iconSize[size]} stroke={1} color={noBackground ? '#888' : 'black'} />
                </div>
                {!hideText && (
                    <div className={`${uppercase ? 'uppercase text-gray-600' : ''}`}>
                        {t(name + (plural ? '_plural' : ''))}
                        {extraText && <span className="text-xs text-gray-500">{extraText}</span>}
                    </div>
                )}
                {rightSection}
            </div>
        </Tooltip>
    );
}
